import { render, staticRenderFns } from "./ClipDetailForm.vue?vue&type=template&id=da64d818&"
import script from "./ClipDetailForm.vue?vue&type=script&lang=ts&"
export * from "./ClipDetailForm.vue?vue&type=script&lang=ts&"
import style0 from "./ClipDetailForm.vue?vue&type=style&index=0&id=da64d818&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports